"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var OrganizationIcon = function OrganizationIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5 4.99a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14h1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1v-14zm12 14v-14H7v14h2v-2c0-1.102.898-2 2-2h2c1.102 0 2 .898 2 2v2h2zm-4 0v-2h-2v2h2zm-4-11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1z"
  }));
};
OrganizationIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "AssetOrganization__icon__iMjNW",
  "metadata-item": "AssetOrganization__metadata-item__eRNQU",
  "metadataItem": "AssetOrganization__metadata-item__eRNQU",
  "metadata-item-wrapper": "AssetOrganization__metadata-item-wrapper__3WIbi",
  "metadataItemWrapper": "AssetOrganization__metadata-item-wrapper__3WIbi"
}; 
require('./AssetOrganization.css');
var AssetOrganization = function AssetOrganization(_ref) {
  var organizationName = _ref.organizationName;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.metadataItemWrapper,
    "data-test-id": "asset-organization-name"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "data-test-id": "asset-organization-icon",
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(OrganizationIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.metadataItem
  }, organizationName));
};
var _default = exports.default = AssetOrganization;
//# sourceMappingURL=AssetOrganization.js.map